// extracted by mini-css-extract-plugin
export default {"container":"xsuGcd_zBWUXuADINUNR","tooltip":"t8ggZQVBgifpI5EworY_"};